import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import { customAxios } from 'lib/axios';
import { Attachment } from 'types';

export const SUBSCRIPTION_STORAGE_LIMIT_CODE = 'SUBSCRIPTION_STORAGE_LIMIT';

type SubscriptionLimitResponse = { code?: string; message?: string };

export const isSubscriptionStorageLimitError = (err: unknown): boolean =>
  axios.isAxiosError(err) &&
  err.response?.status === 402 &&
  (err.response?.data as SubscriptionLimitResponse | undefined)?.code ===
    SUBSCRIPTION_STORAGE_LIMIT_CODE;

const uploadAttachment = async (issueId: string, file: File): Promise<Attachment> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await customAxios.post<Attachment>(
    `/attachments/issues/${issueId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const useUploadAttachment = (issueId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => uploadAttachment(issueId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['attachments', issueId] }).catch(() => undefined);
      queryClient.invalidateQueries({ queryKey: ['issues', issueId] }).catch(() => undefined);
    },
  });
};
